import { ICF_TITLE_PAGE_TITLE } from '../constants/icfTitlePageData';

const TITLE_PAGE_RE = /^title\s*page$/i;

/**
 * Natural sort for ICF sections: Title Page first, then numbered sections (1, 2, … 14).
 */
export function sortIcfSectionsNaturally(sections) {
  return [...(sections || [])].sort((a, b) => {
    const aTitle = a.title || '';
    const bTitle = b.title || '';
    const aIsTitlePage =
      aTitle === ICF_TITLE_PAGE_TITLE || TITLE_PAGE_RE.test(aTitle.trim());
    const bIsTitlePage =
      bTitle === ICF_TITLE_PAGE_TITLE || TITLE_PAGE_RE.test(bTitle.trim());
    if (aIsTitlePage && !bIsTitlePage) return -1;
    if (!aIsTitlePage && bIsTitlePage) return 1;

    const aParts = aTitle.match(/\d+/g)?.map(Number) || [];
    const bParts = bTitle.match(/\d+/g)?.map(Number) || [];
    if (aParts.length === 0 && bParts.length > 0) return 1;
    if (aParts.length > 0 && bParts.length === 0) return -1;
    if (aParts.length === 0 && bParts.length === 0) {
      return aTitle.localeCompare(bTitle, undefined, { numeric: true, sensitivity: 'base' });
    }
    for (let i = 0; i < Math.max(aParts.length, bParts.length); i += 1) {
      const aVal = aParts[i] !== undefined ? aParts[i] : -1;
      const bVal = bParts[i] !== undefined ? bParts[i] : -1;
      if (aVal !== bVal) return aVal - bVal;
    }
    return aTitle.localeCompare(bTitle, undefined, { numeric: true, sensitivity: 'base' });
  });
}
